<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="drawer"
    app
    temporary
    right
    :key="loggedIn"
  >
    <div v-if="loggedIn">
      <router-link
        v-if="creator.user.username"
        :to="{
          name: 'profile',
          params: { username: creator.user.username }
        }"
      >
        <v-list-item @click="$store.dispatch('navigation/closeDrawerView')">
          <v-list-item-avatar>
            <v-img
              v-if="creator.profilePicture"
              :src="creator.profilePicture.small"
              :alt="`${creator.user.username} avatar`"
            ></v-img>
            <v-img
              v-else
              :alt="`${creator.user.username} avatar`"
              :src="require('@/assets/defaultProfilePicture.svg')"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              v-text="creator.user.username"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </router-link>
    </div>
    <v-divider></v-divider>
    <router-link :to="{ name: 'home' }">
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary" v-text="'fas fa-home'"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t('navigation.home')"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
    <div v-if="loggedIn">
      <router-link
        v-if="creator.user.username"
        :to="{
          name: 'profile',
          params: { username: creator.user.username }
        }"
      >
        <v-list-item>
          <v-list-item-icon>
            <v-icon color="primary" v-text="'fas fa-user-alt'"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              v-text="$t('navigation.myProfile')"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </router-link>
       <v-list-group
        v-if="
          accountOrganizations.length &&
            accountOrganizations.some(organization => organization.isModerator)
        "
        :value="true"
        prepend-icon="fas fa-th-large"
        color="primary"
        @click.stop="() => null"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Mes Organisations</v-list-item-title>
          </v-list-item-content>
        </template>
        <router-link
          :to="{
            name: 'organizationHome',
            params: { id: organization.organization.id }
          }"
          v-for="organization in accountOrganizations.filter(
            organization => organization.isModerator
          )"
          :key="organization.organization.id"
        >
          <v-list-item>
            <v-list-item-title
              v-text="organization.organization.name"
            ></v-list-item-title>
          </v-list-item>
        </router-link>
      </v-list-group>
      <v-list-item
        @click="
          () => {
            $store.dispatch('navigation/closeDrawerView');
            $store.dispatch('share/openShareModal');
          }
        "
      >
        <v-list-item-icon>
          <v-icon color="primary" v-text="'fas fa-plus'"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t('app.shareAGem')"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        @click="
          $store.dispatch('navigation/closeDrawerView');
          $store.dispatch('account/logOut');
          $router.push({ name: 'home' });
        "
      >
        <v-list-item-icon>
          <v-icon color="primary" v-text="'fas fa-sign-out-alt'"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            v-text="$t('navigation.signOut')"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
    <div v-else>
      <v-list-item
        @click="
          $store.dispatch('navigation/closeDrawerView');
          $store.dispatch('navigation/openLoginView');
        "
      >
        <v-list-item-icon>
          <v-icon color="primary" v-text="'fas fa-sign-in-alt'"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            v-text="$t('navigation.login')"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        href="https://www.gemmici.com/nos-explorateurs/"
        target="blank"
      >
        <v-list-item-icon>
          <v-icon color="primary" v-text="'fas fa-info-circle'"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            v-text="$t('navigation.becomeCreator')"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>

    <v-divider></v-divider>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      drawer: false
    };
  },
  computed: {
    ...mapState({
      drawerViewState: state => state.navigation.drawer.view,
      creator: state => state.myProfileView.creator,
      accountOrganizations: state => state.organization.accountOrganizations
    }),
    ...mapGetters({
      loggedIn: "account/loggedIn"
    })
  },
  watch: {
    drawerViewState(value) {
      this.drawer = value;
    },
    drawer(value) {
      value !== this.drawerViewState
        ? value
          ? this.$store.dispatch("navigation/openDrawerView")
          : this.$store.dispatch("navigation/closeDrawerView")
        : 0;
    }
  }
};
</script>

<style></style>
